import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

interface JourneySlideItemProps {
  image: string
  description: React.ReactNode
}

export const JourneySlideItem: React.FC<JourneySlideItemProps> = ({
  image,
  description,
}) => {
  return (
    <div className='min-w-0 flex-shrink-0 flex-grow-0 basis-full'>
      <div className='max-md:px-5'>
        <Image
          src={ImageHelper.getImageUrl(image)}
          alt='Journey slide image'
          width={968}
          height={675}
          className='h-full w-full object-cover max-md:rounded-lg md:rounded-r-lg'
        />
      </div>
      <div className='mt-4 px-5 pb-10 font-sans text-base leading-6 text-neutral-700 md:hidden'>
        {description}
      </div>
    </div>
  )
}
